var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.789 0A6.77 6.77 0 000 6.789a6.769 6.769 0 006.789 6.787 6.768 6.768 0 006.787-6.787A6.769 6.769 0 006.789 0zm3.702 7.096c0 .186-.123.309-.309.309H7.561c-.094 0-.155.062-.155.155v2.621c0 .186-.123.309-.309.309H6.48c-.186 0-.309-.123-.309-.309v-2.62c0-.094-.062-.155-.154-.155H3.395c-.186 0-.309-.123-.309-.309V6.48c0-.186.123-.309.309-.309h2.623a.146.146 0 00.154-.154V3.395c0-.186.123-.309.309-.309h.616c.186 0 .309.123.309.309v2.623c0 .092.062.154.155.154h2.621c.186 0 .309.123.309.309v.615zm0 0"}));
}

PlusSign.defaultProps = {"width":"13.576","height":"13.576","viewBox":"0 0 13.576 13.576"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
